import React from 'react';
import { motion } from 'framer-motion';
import { FiExternalLink } from 'react-icons/fi';
import { publicationsData } from '../data/publicationsData';

const Publications = () => {
  return (
    <section id="publications" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
            Publications
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Research work and academic publications
          </p>
        </motion.div>

        <div className="max-w-4xl mx-auto space-y-6">
          {publicationsData.map((publication, index) => (
            <motion.article
              key={publication.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              whileHover={{ y: -4 }}
              className="bg-gray-50 border border-gray-100 rounded-xl shadow-lg p-6 sm:p-9 hover:shadow-xl transition-all duration-300"
            >
              <div className="flex flex-col sm:flex-row sm:items-start gap-5 sm:gap-6">
                <div className="w-20 h-12 shrink-0 flex items-center justify-center rounded-lg border border-blue-100 bg-white px-2 shadow-sm">
                  <img
                    src="/images/logos/ieee-logo.png"
                    alt="IEEE"
                    className="w-full h-auto object-contain"
                  />
                </div>

                <div className="flex-1">
                  <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4">
                    <div>
                      {publication.venueLink ? (
                        <a
                          href={publication.venueLink}
                          target="_blank"
                          rel="noreferrer"
                          title={publication.venue}
                          className="inline-block text-sm font-semibold text-primary hover:text-secondary hover:underline transition-colors duration-200"
                        >
                          {publication.shortVenue || publication.venue}
                        </a>
                      ) : (
                        <p className="text-sm font-semibold text-primary">
                          {publication.shortVenue || publication.venue}
                        </p>
                      )}
                      <h3 className="mt-2 text-xl sm:text-2xl font-bold leading-tight text-gray-900 max-w-3xl">
                        {publication.title}
                      </h3>
                    </div>
                    <span className="w-fit shrink-0 px-3 py-1 rounded-full bg-blue-100 text-blue-700 text-sm font-medium">
                      {publication.status}
                    </span>
                  </div>

                  {publication.authors && (
                    <p className="mt-4 text-sm font-medium leading-6 text-gray-600">
                      {publication.authors}
                    </p>
                  )}

                  <p className="mt-5 pt-5 border-t border-gray-200 text-gray-600 leading-7 max-w-3xl">
                    {publication.description}
                  </p>

                  {publication.link && (
                    <motion.a
                      href={publication.link}
                      target="_blank"
                      rel="noreferrer"
                      whileHover={{ scale: 1.03 }}
                      whileTap={{ scale: 0.97 }}
                      className="inline-flex items-center mt-6 text-gray-700 hover:text-primary transition-colors duration-200"
                    >
                      <FiExternalLink className="w-5 h-5 mr-2" />
                      View on IEEE Xplore
                    </motion.a>
                  )}
                </div>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Publications;
